// Обобщението на „Монитори" — БРОЙ редове и средно време по четирите фази.
//
// Смята се в браузъра, върху ПОКАЗАНИТЕ редове, а не се взима наготово от
// `summary` в отговора. BE-то връща същите числа, но за целия период: напишеш
// ли „Бар" в търсачката, таблицата остава с шепа редове, а кутийките отгоре
// продължават да показват средното на цялото заведение — и нищо на екрана не
// обяснява разликата (същото решение е взето и в „По станции").
//
// Формулата повтаря BE-то едно към едно: средно = цяла част от sum/len, а
// редовете без този статус НЕ влизат в знаменателя (иначе една несготвена
// поръчка дърпа средното надолу, все едно е чакала нула секунди).

import type {
  KitchenMonitorReportRow,
  KitchenMonitorReportSummary,
} from "../../../../api/reportsKitchenMonitors";

/** Секундите на един статус; `null` = редът не е минал през него. */
type SecondsPicker = (row: KitchenMonitorReportRow) => number | null;

const averageSeconds = (
  rows: readonly KitchenMonitorReportRow[],
  pickSeconds: SecondsPicker,
): number | null => {
  let sum = 0;
  let count = 0;
  for (const row of rows) {
    const seconds = pickSeconds(row);
    if (seconds === null || !Number.isFinite(seconds)) continue;
    sum += seconds;
    count += 1;
  }
  // Никой ред не е минал през статуса — тирето е честният отговор, не нулата.
  return count === 0 ? null : Math.trunc(sum / count);
};

export const summarizeKitchenMonitorRows = (
  rows: readonly KitchenMonitorReportRow[],
): KitchenMonitorReportSummary => ({
  items_count: rows.length,
  avg_seconds_to_start: averageSeconds(rows, (row) => row.seconds_to_start),
  avg_seconds_cooking: averageSeconds(rows, (row) => row.seconds_cooking),
  avg_seconds_to_issue: averageSeconds(rows, (row) => row.seconds_to_issue),
  avg_seconds_to_serve: averageSeconds(rows, (row) => row.seconds_to_serve),
});
